module.exports = __webpack_public_path__ + "static/media/persperoni.2ff87fdf.jpg";